import { MutationTree } from 'vuex';
import { EDeletePageMutation } from './delete-page.constants';
import { IDeletePageState } from './delete-page.types';

export const mutations: MutationTree<IDeletePageState> = {
  [EDeletePageMutation.SetDeletedPageId](state: IDeletePageState, pageId: string) {
    state.deletedPageId = pageId;
  },
  [EDeletePageMutation.SetDeleting](state: IDeletePageState, deleting: boolean) {
    state.deleting = deleting;
  },
  [EDeletePageMutation.SetState](state: IDeletePageState, newState: IDeletePageState) {
    Object.assign(state, newState);
  },
};
